import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';
import { useDispatch, useSelector } from 'react-redux';
import { selectVehicle, selectVehicleManufacture } from '../../../../modules/actions/vehicle';
import _ from 'lodash';

const VehicleSelectionPanel = loadable(() => import('../../VehicleSelection/VehicleSelectionPanel'));

const VehicleFilter = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const vehicle = useSelector(state => state.vehicle);
  const dispatch = useDispatch();
  
  const checkIfSelected = (vehicle) => {
      return !_.isEmpty(vehicle.label) && !_.isEmpty(vehicle.datECodePrefix);
  }

const handlePressAll = (e) => {
    if(e.key = "Enter"){
        setIsVisible(!isVisible)
    }
}

const handlePressReset = (e) => {
    if(e.key = "Enter"){
        resetVehicle(e)
    }
}

  useEffect(() => {
      setIsSelected(checkIfSelected(vehicle));
  },[vehicle]);

  const resetVehicle = evt => {
    evt.preventDefault();
    dispatch(selectVehicle({ datECodePrefix: '', label: '' }));
    dispatch(selectVehicleManufacture({
        vehicleManufacturer: '',
        vehicleTypeLabel: '',
        manufacturerLabel: '',
        baseModelLabel: '',
        subModelLabel: '',
        datECodePrefix: '',
        selectedLabel: ''
    }));
};

  return (
      <>
      <div tabIndex={0} className='uk-card uk-card-body' onKeyPress={handlePressAll} onClick={() => setIsVisible(!isVisible)} style={{ cursor: 'pointer' }}>
          <div className="uk-flex uk-flex-between">
              <h4 style={{ fontSize: '1.429rem' }} className='uk-margin-remove'>
                  Mein Fahrzeug
              </h4>
              {isSelected && <span tabIndex={0} onKeyPress={handlePressReset}  uk-icon="icon: trash" className="uk-padding-small" style={{marginRight:"-35px", marginTop:"-5px"}} onClick={resetVehicle} ></span>}
               <span  uk-icon="icon: pencil" className="uk-padding-small" style={{marginTop:"-5px"}} ></span>
          </div>
          {isSelected ? (
              <div className=' uk-background-muted'>{vehicle.label}</div>
          ) : (
              <div className=" uk-background-muted" >
                  <p className="" >Fahrzeug wählen <br/>z.B. Opel Astra , 2000-2013</p>
              </div>
          )}
      </div>
      {isVisible && <VehicleSelectionPanel isVehicleFilter={true}/>}
      </>
  );
}

export default VehicleFilter